// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: brig/bapi.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Token } from "../common/token";
import { Timestamp } from "../google/protobuf/timestamp";
import {
  SbpAddonFeature,
  sbpAddonFeatureFromJSON,
  sbpAddonFeatureToJSON,
  SbpModel,
  sbpModelFromJSON,
  sbpModelToJSON,
  SbpPid,
  sbpPidFromJSON,
  sbpPidToJSON,
  UserRole,
  userRoleFromJSON,
  userRoleToJSON,
} from "../models/auth";
import {
  EntitlementLevel,
  entitlementLevelFromJSON,
  entitlementLevelToJSON,
  Geo,
  geoFromJSON,
  geoToJSON,
} from "../models/global";
import { Organization } from "../models/org";
import { SupportSettings } from "../models/support_settings";
import { Tenant } from "../models/tenant";
import { Eula, SignUpRequirement, signUpRequirementFromJSON, signUpRequirementToJSON, User } from "../models/user";

export const protobufPackage = "brig";

/** StartUserSessionRequest requests the start of a session for the user identified by email. */
export interface StartUserSessionRequest {
  /**
   * Identifies the user, mandatory.  If email identifies a new user, the UserSessionToken returned
   * may only be used with NewOrg.  If disabled user (user, tenant or organization is DISABLED),
   * permission denied is returned.  If enabled user (user, tenant and organization are ENABLED),
   * and no specific tenant is identified, preference is given to tenant the user last logged into.
   */
  email: string;
  /** The single sign on (SSO) identity provider (IDP), optional (default: CISCO). */
  provider: string;
  /** Used only in local setup, optional. */
  planeSpace: boolean;
  /** @deprecated */
  orgName: string;
  /** @deprecated */
  tenantName: string;
  /**
   * Identify a specific tenant by external ID, optional.  If specified, the user identified by email
   * must be an enabled member of this tenant or an error is returned.  May not be specified with
   * organization name or tenant name.
   */
  tenantId: string;
  /**
   * Expiry, if specified, overrides the value the service creating the UserSessionToken would normally provide.
   * An example value of "now+2m" means "2 minutes past the time the UserSessionToken is created".  If empty,
   * the system value is used.  If set, any value that happens after the system value is rejected.
   */
  expiry: string;
  /**
   * A JWT named IdToken from OAUTH2 authentication sequence. Mandatory and
   * must be considered soley (other user identifying parameters such as 'email' must be ignored).
   */
  idToken: string;
  /** Version of the EULA signed by the user. */
  eulaVersion: string;
  /**
   * Identify a specific org that this user can specify to call NewOrg later on to create a personal org
   * that resides in the same cell as the sibling org.
   */
  siblingOrgId: string;
  /** Identifies whether or not user requires sign up. */
  requireSignUp: boolean;
  /** Is true if this is a federated user. */
  federatedUser: boolean;
  /** Tenant ID for users authenticated via CUI. */
  cuiTenantId: string;
  /** The domain that issues the UserSessionToken. */
  issuer: string;
  /**
   * Is true if this login was initiated from an org invitation link.
   * When set, Brig will look for a PENDING user and accept the invitation.
   */
  isInvite: boolean;
}

/**
 * StartUserSessionResponse returns the token the user client must present for every request in this session.
 * If NewUser is true, OrgId, OrgName, TenantId and TenantName will be empty and the UserSessionToken can be
 * used only with NewOrg.
 */
export interface StartUserSessionResponse {
  /** Identifies the user for which the session was started. */
  email: string;
  /** The single sign on (SSO) identity provider (IDP). */
  provider: string;
  /** Identifies the organization in which the session was started. */
  orgId: string;
  /** The name of the organization in which the session was started. */
  orgName: string;
  /**
   * Identifies the tenant in which the session was started.
   * email and tenant_id uniquely identify a user and will be included as claims in UserSessionToken.
   * If tenant_id equals org_id, then this is the default tenant of this organization.
   */
  tenantId: string;
  /** The name of the tenant in which the session was started. */
  tenantName: string;
  /** Is true if this is a new user (not associated with any organization). */
  newUser: boolean;
  /** Is true if this user requires sign up. */
  requireSignUp: boolean;
  /** @deprecated */
  disableSignUp: boolean;
  /** Identifies user's session */
  sessionId: string;
  /** Is true if this is a federated user. */
  federatedUser: boolean;
  cuiTenantId: string;
  /**
   * Is true if the user was just added to a CUI tenant during this login and a forced re-auth
   * is needed to obtain a fresh IdToken that includes the CUI tenant ID.
   */
  forceAuthNeeded: boolean;
  /** Specifies what sign-up steps the user must complete after login. */
  signUpRequirement: SignUpRequirement;
  /** Tokens that should be set in the cookie field of the header of the HTTP response sent back to the client. */
  tokens: Token[];
}

/**
 * RefreshUserSessionRequest replaces the UserSessionToken associated with the session with one
 * that has a later expiry.  Requires a valid UserSessionToken that is not expired.
 * The expiry is calculated at the time the UserSessionToken creator creates the new token.
 */
export interface RefreshUserSessionRequest {
  /**
   * Expiry, if specified, overrides the value the service creating the UserSessionToken would normally provide.
   * An example value of "now+2m" means "2 minutes past the time the UserSessionToken is created".  If empty,
   * the system value is used.  If set, any value that happens after the system value is rejected.
   */
  expiry: string;
}

/** The response to a request for a list of users. */
export interface UsersResponse {
  /** A list of users. */
  users: User[];
}

/**
 * The request for a list of users matching the given search criteria.
 *
 * INTERNAL
 *
 * GetUsersRequest allows an admin to get information on tenant users matching the given
 * search criteria.
 */
export interface GetUsersRequest {
  /**
   * Only return users with these emails.
   * If set, the roles and enabled query parameters are ignored.
   */
  emails: string[];
  /**
   * The single sign on (SSO) identity provider (IDP) of emails, optional.
   * If not specified, provider value is not considered when deciding which users to return.
   */
  provider: string;
  /**
   * Identify a specific tenant, optional.  If not specified, the tenant associated with the
   * current user session making the request is used.  Only users belonging to the resulting
   * tenant are returned.  This parameter allows an admin of the default-tenant to get users
   * of a non-default tenant of the organization.
   */
  tenantId: string;
  /**
   * Only return users that are administratively enabled, otherwise include disabled users as well.
   *
   * INTERNAL
   *
   * The tenant and organization to which the users belong must be enabled regardless of the value of enabled.
   */
  enabled: boolean;
  /** Only return users with specific roles. */
  roles: UserRole[];
  /** Include object metadata in the response. */
  includeMetadata: boolean;
}

/** The request for a specific user. */
export interface GetUserRequest {
  /** The user id or email address. */
  userId: string;
  /** Include object metadata in the response. */
  includeMetadata: boolean;
}

/**
 * The request to add one or more users.
 *
 * INTERNAL
 *
 * SetUsersRequest creates or updates the specified users in the context of this tenant.
 */
export interface SetUsersRequest {
  /**
   * Identify a specific tenant, optional.  If not specified, the tenant associated with the
   * current user session making the request is used.  Users will be created or updated in
   * the resulting tenant.  This parameter allows an admin of the default-tenant to create
   * or update users in a non-default tenant of the organization.
   */
  tenantId: string;
  /**
   * A list of users to be added.
   *
   * INTERNAL
   *
   * A list of users, each one representing a user to be created or updated in the tenant.
   */
  users: User[];
  /**
   * When true, the added users are created in PENDING admin_state and an organization
   * invitation is sent, regardless of the AllowDirectUserAdd server setting. This lets
   * non-enforcing (test/dev) environments exercise the invitation flow on demand. When
   * AllowDirectUserAdd is false, users are always created PENDING and this flag is redundant.
   */
  isInvite: boolean;
  /**
   * dry_run is passed through to the SendOrgInviteEmail API that SetUsers calls when adding PENDING users.
   * When true, a real email is stopped from firing.
   */
  dryRun: boolean;
}

/** The request to delete a specific user. */
export interface DeleteUserRequest {
  /** The user id or email address. */
  userId: string;
}

/** DeleteUsersRequest deletes users. */
export interface DeleteUsersRequest {
  /** The ids of users to be deleted. */
  userId: string[];
}

/**
 * Get subscriptions.
 *
 * This asks for a summary of the subscriptions claimed by the caller's organization.
 */
export interface GetSubscriptionsRequest {
}

/**
 * Subscriptions response.
 *
 * This summarizes the resulting subscriptions after the requested operation on those subscriptions.
 */
export interface SubscriptionsResponse {
  subscriptions: SubscriptionSummary[];
}

/**
 * Claim subscriptions.
 *
 * This is used to specify subscriptions to claim or unclaim.
 */
export interface ClaimSubscriptionsRequest {
  /** The subscription reference identifiers of the subscriptions to claim or unclaim. */
  refId: string[];
}

/** Subscription summary. */
export interface SubscriptionSummary {
  /** The subscription reference identifier. */
  refId: string;
  /** The product ID granted by the subscription. */
  pid: SbpPid;
  /** The quantity of the product ID granted by the subscription. */
  quantity: number;
  /** Entitlement level of the product ID granted by the subscription. */
  level: EntitlementLevel;
  /** Device model of the product ID granted by the subscription. */
  model: SbpModel;
  /** Description of the product ID granted by the subscription. */
  description: string;
  /** When the subscription validity period starts. */
  starts:
    | Date
    | undefined;
  /** Deadline of when the subscription must be renewed in order to remain valid. */
  ends:
    | Date
    | undefined;
  /**
   * Enabled indicates the service from which the pid came from is enabled and the subscription
   * itself is enabled.  If the billing system indicates the subscription is no longer valid,
   * the subscription becomes disabled.
   */
  enabled: boolean;
  feature: SbpAddonFeature;
  /**
   * Hardware strata this license belong to.
   * For the HF native  PIDs this is the device model; for strata-based PIDs this is the strata name (e.g. HF1).
   */
  hardwareStrata: string;
}

/**
 * A list of tenants belonging to an organization.
 *
 * INTERNAL
 *
 * Response to requests with list of tenants.
 * FIXME: models.Tenant should only be Name, Description, Tags, Annotations, Enabled, Metadata, Asn;
 *        models.ProvisionTenants should lose 'set_tenants' and 'del_tenants'.
 *        configd should use only models.ProvisionTenants.
 *        Only brig should use models.Tenant (is the only one creating/updating the tenant themselves).
 */
export interface TenantsResponse {
  /** List of up to date tenants in response to requests with list of tenants. */
  tenants: Tenant[];
}

/** AddTenantRequest allows an admin of the default-tenant (only) to add a non-default tenant. */
export interface AddTenantRequest {
  /** Tenant specification. */
  tenant:
    | Tenant
    | undefined;
  /** Description of first admin user of the new non-default tenant.  User must be enabled with role admin. */
  user: User | undefined;
}

/** Response to AddTenantRequest. */
export interface AddTenantResponse {
  /** Tenant specification. */
  tenant:
    | Tenant
    | undefined;
  /** Description of first admin user of the add non-default tenant. */
  user: User | undefined;
}

/** UpdateTenantRequest allows admin of tenant or default-tenant to update tenant properties. */
export interface UpdateTenantRequest {
  /** The tenant id or name. */
  tenantId: string;
  /** Tenant specification. */
  tenant: Tenant | undefined;
}

/** UpdateTenantsRequest allows admin of the default-tenant updates properties of the one or more tenants. */
export interface UpdateTenantsRequest {
  /** Tenants specifications. */
  tenants: Tenant[];
}

/**
 * GetTenantsRequest allows an admin of the default-tenant (only) to get information on org tenants matching
 * the given search criteria (including the default-tenant).
 */
export interface GetTenantsRequest {
  /** Only return tenants with these names.  If not specified, do not discriminate on tenants based on name. */
  names: string[];
  /** Only return tenants that are administratively enabled. */
  enabled: boolean;
  /** Include object metadata in the response. */
  includeMetadata: boolean;
}

/** GetTenantRequest allows an admin of the default-tenant (only) to get information on a specific tenant. */
export interface GetTenantRequest {
  /** ID or name of tenant of an organization. */
  tenantId: string;
}

/** DeleteTenantRequest allows an admin of the default-tenant to remove a tenant from the organization. */
export interface DeleteTenantRequest {
  /** ID or name of tenant to remove from organization. */
  tenantId: string;
}

/** DeleteTenantsRequest allows an admin of the default-tenant to remove tenants from the organization. */
export interface DeleteTenantsRequest {
  /** A list of tenant IDs, each one representing a tenant to be removed from the organization. */
  tenantId: string[];
}

/**
 * RefreshAgentSessionRequest replaces the AgentSessionToken associated with the session with one
 * that has a later expiry.  Requires a valid AgentSessionToken that is not expired.
 * The expiry is calculated at the time the AgentSessionToken creator creates the new token.
 */
export interface RefreshAgentSessionRequest {
  /**
   * Expiry, if specified, overrides the value the service creating the AgentSessionToken would normally provide.
   * An example value of "now+2m" means "2 minutes past the time the AgentSessionToken is created".  If empty,
   * the system value is used.  If set, any value that happens after the system value is rejected.
   */
  expiry: string;
}

/** StartAgentSessionResponse returns the tokens the switch client must present for every request in this session. */
export interface StartAgentSessionResponse {
  /** Identifies the switch for which the session was started. */
  serialNumber: string;
  /** Identifies the switch for which the session was started. */
  switchId: string;
  /**
   * Identifies the organization to which the switch belongs.
   * Empty value indicates switch has not been bound to an organization.
   */
  orgId: string;
  /**
   * Identifies the fabric_id to which this switch is tied.
   * Empty value indicates switch has not been assigned to a fabric.
   */
  fabricId: string;
  /** The boolean indicate whether the switch is in parking lot org or not */
  unclaimed: boolean;
  /** The boolean indicate whether the switch is bound or not */
  unbound: boolean;
  /** Tokens that should be set in the cookie field of the header of the HTTP response sent back to the switch. */
  tokens: Token[];
}

/** GetAgentSessionRequest allows a switch agent to get information on the current session. */
export interface GetAgentSessionRequest {
}

/** GetAgentSessionResponse includes information about the switch agent of the current session. */
export interface GetAgentSessionResponse {
  /** Identifies the switch of this session. */
  serialNumber: string;
  /** Identifies the switch of this session. */
  switchId: string;
  /**
   * Identifies the organization to which the switch belongs.
   * Empty value indicates switch has not been bound to an organization.
   */
  orgId: string;
  /**
   * The name of the fabric to which the switch is bound.
   * Empty value indicates switch has not been assigned to a fabric.
   */
  fabricId: string;
  /** The boolean indicate whether the switch is in parking lot org or not */
  unclaimed: boolean;
  /** The boolean indicate whether the switch is bound or not */
  unbound: boolean;
  /** Expiration timestamp of this agent session. */
  expiry: Date | undefined;
}

export interface UpdateUser {
  /** The user role. */
  role: UserRole;
  /** Enable/disable the user. */
  enabled: boolean;
  /** A list of user-defined labels that can be used for grouping and filtering Users. */
  labels: string[];
  /** Internal only field. */
  userType: string;
}

/** The request to update a specific user. */
export interface UpdateUserRequest {
  /** The user id or email address. */
  userId: string;
  /** The updated user definition. */
  user: UpdateUser | undefined;
}

/** The request to add a new organization. */
export interface AddOrgRequest {
  /** Name of the company to be added. */
  orgName: string;
  /** The target geo for org creation. If unspecified, the current geo is used. */
  targetGeo: Geo;
}

/** Response to AddOrgRequest. */
export interface AddOrgResponse {
  /** The globally unique identifier of the new organization just created. */
  orgId: string;
  /** Description of the first admin user of the new default-tenant. */
  user:
    | User
    | undefined;
  /** The corresponding CUI tenant identifier for the new organization's default tenant. */
  cuiTenantId: string;
}

/**
 * Request to delete an empty organization.
 *
 * See defintion of the DeleteOrg endpoint for details.
 */
export interface DeleteOrgRequest {
}

/** UpdateSupportAccessRequest allows admin of default-tenant to update support access settings. */
export interface UpdateSupportAccessRequest {
  settings: SupportSettings | undefined;
}

/** GetSupportAccessRequest allows user to read information about support access settings. */
export interface GetSupportAccessRequest {
}

/** SupportAccessResponse includes information about support access settings. */
export interface SupportAccessResponse {
  settings: SupportSettings | undefined;
}

/** DeviceCertRequest contains the  sudi csr that needs to be signed */
export interface SignDeviceCertRequest {
  csr: string;
}

/** DeviceCertResponse contains sudi cert chain, root is not included */
export interface SignDeviceCertResponse {
  certChain: string;
}

/**
 * SignVirtualDeviceCertRequest contains the csr for a virtual device that needs to be signed.
 * The csr must include the target organization id as an X.509 extension with OID OidTortugaOrg.
 */
export interface SignVirtualDeviceCertRequest {
  csr: string;
}

/** SignVirtualDeviceCertResponse contains the virtual device cert chain, root is not included. */
export interface SignVirtualDeviceCertResponse {
  certChain: string;
}

/**
 * InternalSubscriptionRequest  allows user to create internal subscription
 * mmysore_todo add start time and duration
 * mmysore_todo -- any other dates like commit date expiry etc
 */
export interface InternalSubscriptionRequest {
  creator: string;
  refId: string;
  pid: string;
  quantity: number;
  startDate: string;
  term: number;
}

export interface UpdateOrgRequest {
  organization: Organization | undefined;
}

export interface SignEulaRequest {
  eula: Eula | undefined;
}

export interface SignEulaResponse {
  tenantId: string;
}

export interface IntrospectCUITokenRequest {
  token: string;
}

export interface IntrospectCUITokenResponse {
  cuiOrgId: string;
  cuiTenantId: string;
  cuiUserId: string;
}

/** SendOrgInviteEmailRequest requests sending an organization invitation email. */
export interface SendOrgInviteEmailRequest {
  /** The email address of the invited user. Must be a PENDING user of the organization. */
  email: string;
  /**
   * When true, compute and return the invitation data (org name, invite url, etc.) without
   * actually sending the email or updating the invitation status. Intended for tests so they
   * can verify the computed output without firing (and paying for) real emails.
   */
  dryRun: boolean;
}

/**
 * SendOrgInviteEmailResponse returns a copy of the data used to build the invitation
 * (not the email body itself) so callers can confirm what was sent.
 */
export interface SendOrgInviteEmailResponse {
  /** The name of the organization the invitee is being invited to. */
  orgName: string;
  /** The UUID of the organization the invitee is being invited to. */
  orgId: string;
  /** The invitation acceptance URL embedded in the email. */
  inviteUrl: string;
  /** The email address of the user who initiated the invitation. */
  requesterEmail: string;
  /** The email address of the invited user. */
  inviteeEmail: string;
  /** The time at which the invitation (and its embedded token) expires. */
  expiresAt:
    | Date
    | undefined;
  /** The time at which the invitation was sent. */
  sentAt: Date | undefined;
}

/** C3UserSessionStartRequest requests the start of a session for the C3 user identified by CUI user ID. */
export interface C3UserSessionStartRequest {
  /** A JWT from OAUTH2 token exchange sequence. This is the decrypted CUI-for-Hyperfabric-Access-Token. */
  accessToken: string;
  /** The domain that issues the UserSessionToken. */
  issuer: string;
  /** Is this crosslaunched from C3 */
  isCrosslaunch: boolean;
  /** C3 base url that initiated the crosslaunch */
  c3BaseUrl: string;
}

function createBaseStartUserSessionRequest(): StartUserSessionRequest {
  return {
    email: "",
    provider: "",
    planeSpace: false,
    orgName: "",
    tenantName: "",
    tenantId: "",
    expiry: "",
    idToken: "",
    eulaVersion: "",
    siblingOrgId: "",
    requireSignUp: false,
    federatedUser: false,
    cuiTenantId: "",
    issuer: "",
    isInvite: false,
  };
}

export const StartUserSessionRequest: MessageFns<StartUserSessionRequest> = {
  encode(message: StartUserSessionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    if (message.provider !== "") {
      writer.uint32(18).string(message.provider);
    }
    if (message.planeSpace !== false) {
      writer.uint32(24).bool(message.planeSpace);
    }
    if (message.orgName !== "") {
      writer.uint32(42).string(message.orgName);
    }
    if (message.tenantName !== "") {
      writer.uint32(50).string(message.tenantName);
    }
    if (message.tenantId !== "") {
      writer.uint32(58).string(message.tenantId);
    }
    if (message.expiry !== "") {
      writer.uint32(66).string(message.expiry);
    }
    if (message.idToken !== "") {
      writer.uint32(74).string(message.idToken);
    }
    if (message.eulaVersion !== "") {
      writer.uint32(82).string(message.eulaVersion);
    }
    if (message.siblingOrgId !== "") {
      writer.uint32(90).string(message.siblingOrgId);
    }
    if (message.requireSignUp !== false) {
      writer.uint32(96).bool(message.requireSignUp);
    }
    if (message.federatedUser !== false) {
      writer.uint32(104).bool(message.federatedUser);
    }
    if (message.cuiTenantId !== "") {
      writer.uint32(114).string(message.cuiTenantId);
    }
    if (message.issuer !== "") {
      writer.uint32(122).string(message.issuer);
    }
    if (message.isInvite !== false) {
      writer.uint32(128).bool(message.isInvite);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartUserSessionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartUserSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.planeSpace = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.orgName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.tenantName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.tenantId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.expiry = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.idToken = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.eulaVersion = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.siblingOrgId = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.requireSignUp = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.federatedUser = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.cuiTenantId = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.issuer = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.isInvite = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartUserSessionRequest {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      planeSpace: isSet(object.planeSpace) ? globalThis.Boolean(object.planeSpace) : false,
      orgName: isSet(object.orgName) ? globalThis.String(object.orgName) : "",
      tenantName: isSet(object.tenantName) ? globalThis.String(object.tenantName) : "",
      tenantId: isSet(object.tenantId) ? globalThis.String(object.tenantId) : "",
      expiry: isSet(object.expiry) ? globalThis.String(object.expiry) : "",
      idToken: isSet(object.idToken) ? globalThis.String(object.idToken) : "",
      eulaVersion: isSet(object.eulaVersion) ? globalThis.String(object.eulaVersion) : "",
      siblingOrgId: isSet(object.siblingOrgId) ? globalThis.String(object.siblingOrgId) : "",
      requireSignUp: isSet(object.requireSignUp) ? globalThis.Boolean(object.requireSignUp) : false,
      federatedUser: isSet(object.federatedUser) ? globalThis.Boolean(object.federatedUser) : false,
      cuiTenantId: isSet(object.cuiTenantId) ? globalThis.String(object.cuiTenantId) : "",
      issuer: isSet(object.issuer) ? globalThis.String(object.issuer) : "",
      isInvite: isSet(object.isInvite) ? globalThis.Boolean(object.isInvite) : false,
    };
  },

  toJSON(message: StartUserSessionRequest): unknown {
    const obj: any = {};
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.planeSpace !== false) {
      obj.planeSpace = message.planeSpace;
    }
    if (message.orgName !== "") {
      obj.orgName = message.orgName;
    }
    if (message.tenantName !== "") {
      obj.tenantName = message.tenantName;
    }
    if (message.tenantId !== "") {
      obj.tenantId = message.tenantId;
    }
    if (message.expiry !== "") {
      obj.expiry = message.expiry;
    }
    if (message.idToken !== "") {
      obj.idToken = message.idToken;
    }
    if (message.eulaVersion !== "") {
      obj.eulaVersion = message.eulaVersion;
    }
    if (message.siblingOrgId !== "") {
      obj.siblingOrgId = message.siblingOrgId;
    }
    if (message.requireSignUp !== false) {
      obj.requireSignUp = message.requireSignUp;
    }
    if (message.federatedUser !== false) {
      obj.federatedUser = message.federatedUser;
    }
    if (message.cuiTenantId !== "") {
      obj.cuiTenantId = message.cuiTenantId;
    }
    if (message.issuer !== "") {
      obj.issuer = message.issuer;
    }
    if (message.isInvite !== false) {
      obj.isInvite = message.isInvite;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StartUserSessionRequest>, I>>(base?: I): StartUserSessionRequest {
    return StartUserSessionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StartUserSessionRequest>, I>>(object: I): StartUserSessionRequest {
    const message = createBaseStartUserSessionRequest();
    message.email = object.email ?? "";
    message.provider = object.provider ?? "";
    message.planeSpace = object.planeSpace ?? false;
    message.orgName = object.orgName ?? "";
    message.tenantName = object.tenantName ?? "";
    message.tenantId = object.tenantId ?? "";
    message.expiry = object.expiry ?? "";
    message.idToken = object.idToken ?? "";
    message.eulaVersion = object.eulaVersion ?? "";
    message.siblingOrgId = object.siblingOrgId ?? "";
    message.requireSignUp = object.requireSignUp ?? false;
    message.federatedUser = object.federatedUser ?? false;
    message.cuiTenantId = object.cuiTenantId ?? "";
    message.issuer = object.issuer ?? "";
    message.isInvite = object.isInvite ?? false;
    return message;
  },
};

function createBaseStartUserSessionResponse(): StartUserSessionResponse {
  return {
    email: "",
    provider: "",
    orgId: "",
    orgName: "",
    tenantId: "",
    tenantName: "",
    newUser: false,
    requireSignUp: false,
    disableSignUp: false,
    sessionId: "",
    federatedUser: false,
    cuiTenantId: "",
    forceAuthNeeded: false,
    signUpRequirement: 0,
    tokens: [],
  };
}

export const StartUserSessionResponse: MessageFns<StartUserSessionResponse> = {
  encode(message: StartUserSessionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    if (message.provider !== "") {
      writer.uint32(18).string(message.provider);
    }
    if (message.orgId !== "") {
      writer.uint32(26).string(message.orgId);
    }
    if (message.orgName !== "") {
      writer.uint32(34).string(message.orgName);
    }
    if (message.tenantId !== "") {
      writer.uint32(42).string(message.tenantId);
    }
    if (message.tenantName !== "") {
      writer.uint32(50).string(message.tenantName);
    }
    if (message.newUser !== false) {
      writer.uint32(56).bool(message.newUser);
    }
    if (message.requireSignUp !== false) {
      writer.uint32(64).bool(message.requireSignUp);
    }
    if (message.disableSignUp !== false) {
      writer.uint32(72).bool(message.disableSignUp);
    }
    if (message.sessionId !== "") {
      writer.uint32(82).string(message.sessionId);
    }
    if (message.federatedUser !== false) {
      writer.uint32(88).bool(message.federatedUser);
    }
    if (message.cuiTenantId !== "") {
      writer.uint32(98).string(message.cuiTenantId);
    }
    if (message.forceAuthNeeded !== false) {
      writer.uint32(104).bool(message.forceAuthNeeded);
    }
    if (message.signUpRequirement !== 0) {
      writer.uint32(112).int32(message.signUpRequirement);
    }
    for (const v of message.tokens) {
      Token.encode(v!, writer.uint32(402).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartUserSessionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartUserSessionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.orgName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.tenantId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.tenantName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.newUser = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.requireSignUp = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.disableSignUp = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.sessionId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.federatedUser = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.cuiTenantId = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.forceAuthNeeded = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.signUpRequirement = reader.int32() as any;
          continue;
        }
        case 50: {
          if (tag !== 402) {
            break;
          }

          message.tokens.push(Token.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartUserSessionResponse {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      orgName: isSet(object.orgName) ? globalThis.String(object.orgName) : "",
      tenantId: isSet(object.tenantId) ? globalThis.String(object.tenantId) : "",
      tenantName: isSet(object.tenantName) ? globalThis.String(object.tenantName) : "",
      newUser: isSet(object.newUser) ? globalThis.Boolean(object.newUser) : false,
      requireSignUp: isSet(object.requireSignUp) ? globalThis.Boolean(object.requireSignUp) : false,
      disableSignUp: isSet(object.disableSignUp) ? globalThis.Boolean(object.disableSignUp) : false,
      sessionId: isSet(object.sessionId) ? globalThis.String(object.sessionId) : "",
      federatedUser: isSet(object.federatedUser) ? globalThis.Boolean(object.federatedUser) : false,
      cuiTenantId: isSet(object.cuiTenantId) ? globalThis.String(object.cuiTenantId) : "",
      forceAuthNeeded: isSet(object.forceAuthNeeded) ? globalThis.Boolean(object.forceAuthNeeded) : false,
      signUpRequirement: isSet(object.signUpRequirement) ? signUpRequirementFromJSON(object.signUpRequirement) : 0,
      tokens: globalThis.Array.isArray(object?.tokens) ? object.tokens.map((e: any) => Token.fromJSON(e)) : [],
    };
  },

  toJSON(message: StartUserSessionResponse): unknown {
    const obj: any = {};
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.orgName !== "") {
      obj.orgName = message.orgName;
    }
    if (message.tenantId !== "") {
      obj.tenantId = message.tenantId;
    }
    if (message.tenantName !== "") {
      obj.tenantName = message.tenantName;
    }
    if (message.newUser !== false) {
      obj.newUser = message.newUser;
    }
    if (message.requireSignUp !== false) {
      obj.requireSignUp = message.requireSignUp;
    }
    if (message.disableSignUp !== false) {
      obj.disableSignUp = message.disableSignUp;
    }
    if (message.sessionId !== "") {
      obj.sessionId = message.sessionId;
    }
    if (message.federatedUser !== false) {
      obj.federatedUser = message.federatedUser;
    }
    if (message.cuiTenantId !== "") {
      obj.cuiTenantId = message.cuiTenantId;
    }
    if (message.forceAuthNeeded !== false) {
      obj.forceAuthNeeded = message.forceAuthNeeded;
    }
    if (message.signUpRequirement !== 0) {
      obj.signUpRequirement = signUpRequirementToJSON(message.signUpRequirement);
    }
    if (message.tokens?.length) {
      obj.tokens = message.tokens.map((e) => Token.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StartUserSessionResponse>, I>>(base?: I): StartUserSessionResponse {
    return StartUserSessionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StartUserSessionResponse>, I>>(object: I): StartUserSessionResponse {
    const message = createBaseStartUserSessionResponse();
    message.email = object.email ?? "";
    message.provider = object.provider ?? "";
    message.orgId = object.orgId ?? "";
    message.orgName = object.orgName ?? "";
    message.tenantId = object.tenantId ?? "";
    message.tenantName = object.tenantName ?? "";
    message.newUser = object.newUser ?? false;
    message.requireSignUp = object.requireSignUp ?? false;
    message.disableSignUp = object.disableSignUp ?? false;
    message.sessionId = object.sessionId ?? "";
    message.federatedUser = object.federatedUser ?? false;
    message.cuiTenantId = object.cuiTenantId ?? "";
    message.forceAuthNeeded = object.forceAuthNeeded ?? false;
    message.signUpRequirement = object.signUpRequirement ?? 0;
    message.tokens = object.tokens?.map((e) => Token.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRefreshUserSessionRequest(): RefreshUserSessionRequest {
  return { expiry: "" };
}

export const RefreshUserSessionRequest: MessageFns<RefreshUserSessionRequest> = {
  encode(message: RefreshUserSessionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.expiry !== "") {
      writer.uint32(10).string(message.expiry);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RefreshUserSessionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRefreshUserSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.expiry = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RefreshUserSessionRequest {
    return { expiry: isSet(object.expiry) ? globalThis.String(object.expiry) : "" };
  },

  toJSON(message: RefreshUserSessionRequest): unknown {
    const obj: any = {};
    if (message.expiry !== "") {
      obj.expiry = message.expiry;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RefreshUserSessionRequest>, I>>(base?: I): RefreshUserSessionRequest {
    return RefreshUserSessionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RefreshUserSessionRequest>, I>>(object: I): RefreshUserSessionRequest {
    const message = createBaseRefreshUserSessionRequest();
    message.expiry = object.expiry ?? "";
    return message;
  },
};

function createBaseUsersResponse(): UsersResponse {
  return { users: [] };
}

export const UsersResponse: MessageFns<UsersResponse> = {
  encode(message: UsersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.users) {
      User.encode(v!, writer.uint32(170).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UsersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUsersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.users.push(User.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UsersResponse {
    return { users: globalThis.Array.isArray(object?.users) ? object.users.map((e: any) => User.fromJSON(e)) : [] };
  },

  toJSON(message: UsersResponse): unknown {
    const obj: any = {};
    if (message.users?.length) {
      obj.users = message.users.map((e) => User.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UsersResponse>, I>>(base?: I): UsersResponse {
    return UsersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UsersResponse>, I>>(object: I): UsersResponse {
    const message = createBaseUsersResponse();
    message.users = object.users?.map((e) => User.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetUsersRequest(): GetUsersRequest {
  return { emails: [], provider: "", tenantId: "", enabled: false, roles: [], includeMetadata: false };
}

export const GetUsersRequest: MessageFns<GetUsersRequest> = {
  encode(message: GetUsersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.emails) {
      writer.uint32(10).string(v!);
    }
    if (message.provider !== "") {
      writer.uint32(18).string(message.provider);
    }
    if (message.tenantId !== "") {
      writer.uint32(26).string(message.tenantId);
    }
    if (message.enabled !== false) {
      writer.uint32(32).bool(message.enabled);
    }
    writer.uint32(42).fork();
    for (const v of message.roles) {
      writer.int32(v);
    }
    writer.join();
    if (message.includeMetadata !== false) {
      writer.uint32(48).bool(message.includeMetadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetUsersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUsersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.emails.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tenantId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 5: {
          if (tag === 40) {
            message.roles.push(reader.int32() as any);

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.roles.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUsersRequest {
    return {
      emails: globalThis.Array.isArray(object?.emails) ? object.emails.map((e: any) => globalThis.String(e)) : [],
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      tenantId: isSet(object.tenantId) ? globalThis.String(object.tenantId) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      roles: globalThis.Array.isArray(object?.roles) ? object.roles.map((e: any) => userRoleFromJSON(e)) : [],
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
    };
  },

  toJSON(message: GetUsersRequest): unknown {
    const obj: any = {};
    if (message.emails?.length) {
      obj.emails = message.emails;
    }
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.tenantId !== "") {
      obj.tenantId = message.tenantId;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.roles?.length) {
      obj.roles = message.roles.map((e) => userRoleToJSON(e));
    }
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetUsersRequest>, I>>(base?: I): GetUsersRequest {
    return GetUsersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetUsersRequest>, I>>(object: I): GetUsersRequest {
    const message = createBaseGetUsersRequest();
    message.emails = object.emails?.map((e) => e) || [];
    message.provider = object.provider ?? "";
    message.tenantId = object.tenantId ?? "";
    message.enabled = object.enabled ?? false;
    message.roles = object.roles?.map((e) => e) || [];
    message.includeMetadata = object.includeMetadata ?? false;
    return message;
  },
};

function createBaseGetUserRequest(): GetUserRequest {
  return { userId: "", includeMetadata: false };
}

export const GetUserRequest: MessageFns<GetUserRequest> = {
  encode(message: GetUserRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.includeMetadata !== false) {
      writer.uint32(16).bool(message.includeMetadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetUserRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUserRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUserRequest {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
    };
  },

  toJSON(message: GetUserRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetUserRequest>, I>>(base?: I): GetUserRequest {
    return GetUserRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetUserRequest>, I>>(object: I): GetUserRequest {
    const message = createBaseGetUserRequest();
    message.userId = object.userId ?? "";
    message.includeMetadata = object.includeMetadata ?? false;
    return message;
  },
};

function createBaseSetUsersRequest(): SetUsersRequest {
  return { tenantId: "", users: [], isInvite: false, dryRun: false };
}

export const SetUsersRequest: MessageFns<SetUsersRequest> = {
  encode(message: SetUsersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tenantId !== "") {
      writer.uint32(10).string(message.tenantId);
    }
    for (const v of message.users) {
      User.encode(v!, writer.uint32(170).fork()).join();
    }
    if (message.isInvite !== false) {
      writer.uint32(176).bool(message.isInvite);
    }
    if (message.dryRun !== false) {
      writer.uint32(184).bool(message.dryRun);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetUsersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetUsersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tenantId = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.users.push(User.decode(reader, reader.uint32()));
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.isInvite = reader.bool();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.dryRun = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetUsersRequest {
    return {
      tenantId: isSet(object.tenantId) ? globalThis.String(object.tenantId) : "",
      users: globalThis.Array.isArray(object?.users) ? object.users.map((e: any) => User.fromJSON(e)) : [],
      isInvite: isSet(object.isInvite) ? globalThis.Boolean(object.isInvite) : false,
      dryRun: isSet(object.dryRun) ? globalThis.Boolean(object.dryRun) : false,
    };
  },

  toJSON(message: SetUsersRequest): unknown {
    const obj: any = {};
    if (message.tenantId !== "") {
      obj.tenantId = message.tenantId;
    }
    if (message.users?.length) {
      obj.users = message.users.map((e) => User.toJSON(e));
    }
    if (message.isInvite !== false) {
      obj.isInvite = message.isInvite;
    }
    if (message.dryRun !== false) {
      obj.dryRun = message.dryRun;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetUsersRequest>, I>>(base?: I): SetUsersRequest {
    return SetUsersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetUsersRequest>, I>>(object: I): SetUsersRequest {
    const message = createBaseSetUsersRequest();
    message.tenantId = object.tenantId ?? "";
    message.users = object.users?.map((e) => User.fromPartial(e)) || [];
    message.isInvite = object.isInvite ?? false;
    message.dryRun = object.dryRun ?? false;
    return message;
  },
};

function createBaseDeleteUserRequest(): DeleteUserRequest {
  return { userId: "" };
}

export const DeleteUserRequest: MessageFns<DeleteUserRequest> = {
  encode(message: DeleteUserRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteUserRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteUserRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteUserRequest {
    return { userId: isSet(object.userId) ? globalThis.String(object.userId) : "" };
  },

  toJSON(message: DeleteUserRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteUserRequest>, I>>(base?: I): DeleteUserRequest {
    return DeleteUserRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteUserRequest>, I>>(object: I): DeleteUserRequest {
    const message = createBaseDeleteUserRequest();
    message.userId = object.userId ?? "";
    return message;
  },
};

function createBaseDeleteUsersRequest(): DeleteUsersRequest {
  return { userId: [] };
}

export const DeleteUsersRequest: MessageFns<DeleteUsersRequest> = {
  encode(message: DeleteUsersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.userId) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteUsersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteUsersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteUsersRequest {
    return {
      userId: globalThis.Array.isArray(object?.userId) ? object.userId.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: DeleteUsersRequest): unknown {
    const obj: any = {};
    if (message.userId?.length) {
      obj.userId = message.userId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteUsersRequest>, I>>(base?: I): DeleteUsersRequest {
    return DeleteUsersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteUsersRequest>, I>>(object: I): DeleteUsersRequest {
    const message = createBaseDeleteUsersRequest();
    message.userId = object.userId?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetSubscriptionsRequest(): GetSubscriptionsRequest {
  return {};
}

export const GetSubscriptionsRequest: MessageFns<GetSubscriptionsRequest> = {
  encode(_: GetSubscriptionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSubscriptionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSubscriptionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetSubscriptionsRequest {
    return {};
  },

  toJSON(_: GetSubscriptionsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSubscriptionsRequest>, I>>(base?: I): GetSubscriptionsRequest {
    return GetSubscriptionsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSubscriptionsRequest>, I>>(_: I): GetSubscriptionsRequest {
    const message = createBaseGetSubscriptionsRequest();
    return message;
  },
};

function createBaseSubscriptionsResponse(): SubscriptionsResponse {
  return { subscriptions: [] };
}

export const SubscriptionsResponse: MessageFns<SubscriptionsResponse> = {
  encode(message: SubscriptionsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.subscriptions) {
      SubscriptionSummary.encode(v!, writer.uint32(802).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubscriptionsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscriptionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.subscriptions.push(SubscriptionSummary.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscriptionsResponse {
    return {
      subscriptions: globalThis.Array.isArray(object?.subscriptions)
        ? object.subscriptions.map((e: any) => SubscriptionSummary.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SubscriptionsResponse): unknown {
    const obj: any = {};
    if (message.subscriptions?.length) {
      obj.subscriptions = message.subscriptions.map((e) => SubscriptionSummary.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubscriptionsResponse>, I>>(base?: I): SubscriptionsResponse {
    return SubscriptionsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubscriptionsResponse>, I>>(object: I): SubscriptionsResponse {
    const message = createBaseSubscriptionsResponse();
    message.subscriptions = object.subscriptions?.map((e) => SubscriptionSummary.fromPartial(e)) || [];
    return message;
  },
};

function createBaseClaimSubscriptionsRequest(): ClaimSubscriptionsRequest {
  return { refId: [] };
}

export const ClaimSubscriptionsRequest: MessageFns<ClaimSubscriptionsRequest> = {
  encode(message: ClaimSubscriptionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.refId) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClaimSubscriptionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClaimSubscriptionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.refId.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClaimSubscriptionsRequest {
    return { refId: globalThis.Array.isArray(object?.refId) ? object.refId.map((e: any) => globalThis.String(e)) : [] };
  },

  toJSON(message: ClaimSubscriptionsRequest): unknown {
    const obj: any = {};
    if (message.refId?.length) {
      obj.refId = message.refId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClaimSubscriptionsRequest>, I>>(base?: I): ClaimSubscriptionsRequest {
    return ClaimSubscriptionsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClaimSubscriptionsRequest>, I>>(object: I): ClaimSubscriptionsRequest {
    const message = createBaseClaimSubscriptionsRequest();
    message.refId = object.refId?.map((e) => e) || [];
    return message;
  },
};

function createBaseSubscriptionSummary(): SubscriptionSummary {
  return {
    refId: "",
    pid: 0,
    quantity: 0,
    level: 0,
    model: 0,
    description: "",
    starts: undefined,
    ends: undefined,
    enabled: false,
    feature: 0,
    hardwareStrata: "",
  };
}

export const SubscriptionSummary: MessageFns<SubscriptionSummary> = {
  encode(message: SubscriptionSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.refId !== "") {
      writer.uint32(10).string(message.refId);
    }
    if (message.pid !== 0) {
      writer.uint32(16).int32(message.pid);
    }
    if (message.quantity !== 0) {
      writer.uint32(24).uint32(message.quantity);
    }
    if (message.level !== 0) {
      writer.uint32(32).int32(message.level);
    }
    if (message.model !== 0) {
      writer.uint32(40).int32(message.model);
    }
    if (message.description !== "") {
      writer.uint32(50).string(message.description);
    }
    if (message.starts !== undefined) {
      Timestamp.encode(toTimestamp(message.starts), writer.uint32(58).fork()).join();
    }
    if (message.ends !== undefined) {
      Timestamp.encode(toTimestamp(message.ends), writer.uint32(66).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(72).bool(message.enabled);
    }
    if (message.feature !== 0) {
      writer.uint32(80).int32(message.feature);
    }
    if (message.hardwareStrata !== "") {
      writer.uint32(90).string(message.hardwareStrata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubscriptionSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscriptionSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.refId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.pid = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.quantity = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.level = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.model = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.starts = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.ends = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.feature = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.hardwareStrata = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscriptionSummary {
    return {
      refId: isSet(object.refId) ? globalThis.String(object.refId) : "",
      pid: isSet(object.pid) ? sbpPidFromJSON(object.pid) : 0,
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      level: isSet(object.level) ? entitlementLevelFromJSON(object.level) : 0,
      model: isSet(object.model) ? sbpModelFromJSON(object.model) : 0,
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      starts: isSet(object.starts) ? fromJsonTimestamp(object.starts) : undefined,
      ends: isSet(object.ends) ? fromJsonTimestamp(object.ends) : undefined,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      feature: isSet(object.feature) ? sbpAddonFeatureFromJSON(object.feature) : 0,
      hardwareStrata: isSet(object.hardwareStrata) ? globalThis.String(object.hardwareStrata) : "",
    };
  },

  toJSON(message: SubscriptionSummary): unknown {
    const obj: any = {};
    if (message.refId !== "") {
      obj.refId = message.refId;
    }
    if (message.pid !== 0) {
      obj.pid = sbpPidToJSON(message.pid);
    }
    if (message.quantity !== 0) {
      obj.quantity = Math.round(message.quantity);
    }
    if (message.level !== 0) {
      obj.level = entitlementLevelToJSON(message.level);
    }
    if (message.model !== 0) {
      obj.model = sbpModelToJSON(message.model);
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.starts !== undefined) {
      obj.starts = message.starts.toISOString();
    }
    if (message.ends !== undefined) {
      obj.ends = message.ends.toISOString();
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.feature !== 0) {
      obj.feature = sbpAddonFeatureToJSON(message.feature);
    }
    if (message.hardwareStrata !== "") {
      obj.hardwareStrata = message.hardwareStrata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubscriptionSummary>, I>>(base?: I): SubscriptionSummary {
    return SubscriptionSummary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubscriptionSummary>, I>>(object: I): SubscriptionSummary {
    const message = createBaseSubscriptionSummary();
    message.refId = object.refId ?? "";
    message.pid = object.pid ?? 0;
    message.quantity = object.quantity ?? 0;
    message.level = object.level ?? 0;
    message.model = object.model ?? 0;
    message.description = object.description ?? "";
    message.starts = object.starts ?? undefined;
    message.ends = object.ends ?? undefined;
    message.enabled = object.enabled ?? false;
    message.feature = object.feature ?? 0;
    message.hardwareStrata = object.hardwareStrata ?? "";
    return message;
  },
};

function createBaseTenantsResponse(): TenantsResponse {
  return { tenants: [] };
}

export const TenantsResponse: MessageFns<TenantsResponse> = {
  encode(message: TenantsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tenants) {
      Tenant.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TenantsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTenantsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tenants.push(Tenant.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TenantsResponse {
    return {
      tenants: globalThis.Array.isArray(object?.tenants) ? object.tenants.map((e: any) => Tenant.fromJSON(e)) : [],
    };
  },

  toJSON(message: TenantsResponse): unknown {
    const obj: any = {};
    if (message.tenants?.length) {
      obj.tenants = message.tenants.map((e) => Tenant.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TenantsResponse>, I>>(base?: I): TenantsResponse {
    return TenantsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TenantsResponse>, I>>(object: I): TenantsResponse {
    const message = createBaseTenantsResponse();
    message.tenants = object.tenants?.map((e) => Tenant.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAddTenantRequest(): AddTenantRequest {
  return { tenant: undefined, user: undefined };
}

export const AddTenantRequest: MessageFns<AddTenantRequest> = {
  encode(message: AddTenantRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tenant !== undefined) {
      Tenant.encode(message.tenant, writer.uint32(10).fork()).join();
    }
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddTenantRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddTenantRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tenant = Tenant.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.user = User.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddTenantRequest {
    return {
      tenant: isSet(object.tenant) ? Tenant.fromJSON(object.tenant) : undefined,
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
    };
  },

  toJSON(message: AddTenantRequest): unknown {
    const obj: any = {};
    if (message.tenant !== undefined) {
      obj.tenant = Tenant.toJSON(message.tenant);
    }
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddTenantRequest>, I>>(base?: I): AddTenantRequest {
    return AddTenantRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddTenantRequest>, I>>(object: I): AddTenantRequest {
    const message = createBaseAddTenantRequest();
    message.tenant = (object.tenant !== undefined && object.tenant !== null)
      ? Tenant.fromPartial(object.tenant)
      : undefined;
    message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
    return message;
  },
};

function createBaseAddTenantResponse(): AddTenantResponse {
  return { tenant: undefined, user: undefined };
}

export const AddTenantResponse: MessageFns<AddTenantResponse> = {
  encode(message: AddTenantResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tenant !== undefined) {
      Tenant.encode(message.tenant, writer.uint32(10).fork()).join();
    }
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddTenantResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddTenantResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tenant = Tenant.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.user = User.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddTenantResponse {
    return {
      tenant: isSet(object.tenant) ? Tenant.fromJSON(object.tenant) : undefined,
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
    };
  },

  toJSON(message: AddTenantResponse): unknown {
    const obj: any = {};
    if (message.tenant !== undefined) {
      obj.tenant = Tenant.toJSON(message.tenant);
    }
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddTenantResponse>, I>>(base?: I): AddTenantResponse {
    return AddTenantResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddTenantResponse>, I>>(object: I): AddTenantResponse {
    const message = createBaseAddTenantResponse();
    message.tenant = (object.tenant !== undefined && object.tenant !== null)
      ? Tenant.fromPartial(object.tenant)
      : undefined;
    message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
    return message;
  },
};

function createBaseUpdateTenantRequest(): UpdateTenantRequest {
  return { tenantId: "", tenant: undefined };
}

export const UpdateTenantRequest: MessageFns<UpdateTenantRequest> = {
  encode(message: UpdateTenantRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tenantId !== "") {
      writer.uint32(10).string(message.tenantId);
    }
    if (message.tenant !== undefined) {
      Tenant.encode(message.tenant, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateTenantRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateTenantRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tenantId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tenant = Tenant.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateTenantRequest {
    return {
      tenantId: isSet(object.tenantId) ? globalThis.String(object.tenantId) : "",
      tenant: isSet(object.tenant) ? Tenant.fromJSON(object.tenant) : undefined,
    };
  },

  toJSON(message: UpdateTenantRequest): unknown {
    const obj: any = {};
    if (message.tenantId !== "") {
      obj.tenantId = message.tenantId;
    }
    if (message.tenant !== undefined) {
      obj.tenant = Tenant.toJSON(message.tenant);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateTenantRequest>, I>>(base?: I): UpdateTenantRequest {
    return UpdateTenantRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateTenantRequest>, I>>(object: I): UpdateTenantRequest {
    const message = createBaseUpdateTenantRequest();
    message.tenantId = object.tenantId ?? "";
    message.tenant = (object.tenant !== undefined && object.tenant !== null)
      ? Tenant.fromPartial(object.tenant)
      : undefined;
    return message;
  },
};

function createBaseUpdateTenantsRequest(): UpdateTenantsRequest {
  return { tenants: [] };
}

export const UpdateTenantsRequest: MessageFns<UpdateTenantsRequest> = {
  encode(message: UpdateTenantsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tenants) {
      Tenant.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateTenantsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateTenantsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tenants.push(Tenant.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateTenantsRequest {
    return {
      tenants: globalThis.Array.isArray(object?.tenants) ? object.tenants.map((e: any) => Tenant.fromJSON(e)) : [],
    };
  },

  toJSON(message: UpdateTenantsRequest): unknown {
    const obj: any = {};
    if (message.tenants?.length) {
      obj.tenants = message.tenants.map((e) => Tenant.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateTenantsRequest>, I>>(base?: I): UpdateTenantsRequest {
    return UpdateTenantsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateTenantsRequest>, I>>(object: I): UpdateTenantsRequest {
    const message = createBaseUpdateTenantsRequest();
    message.tenants = object.tenants?.map((e) => Tenant.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetTenantsRequest(): GetTenantsRequest {
  return { names: [], enabled: false, includeMetadata: false };
}

export const GetTenantsRequest: MessageFns<GetTenantsRequest> = {
  encode(message: GetTenantsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.names) {
      writer.uint32(10).string(v!);
    }
    if (message.enabled !== false) {
      writer.uint32(16).bool(message.enabled);
    }
    if (message.includeMetadata !== false) {
      writer.uint32(24).bool(message.includeMetadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTenantsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTenantsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.names.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTenantsRequest {
    return {
      names: globalThis.Array.isArray(object?.names) ? object.names.map((e: any) => globalThis.String(e)) : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
    };
  },

  toJSON(message: GetTenantsRequest): unknown {
    const obj: any = {};
    if (message.names?.length) {
      obj.names = message.names;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTenantsRequest>, I>>(base?: I): GetTenantsRequest {
    return GetTenantsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTenantsRequest>, I>>(object: I): GetTenantsRequest {
    const message = createBaseGetTenantsRequest();
    message.names = object.names?.map((e) => e) || [];
    message.enabled = object.enabled ?? false;
    message.includeMetadata = object.includeMetadata ?? false;
    return message;
  },
};

function createBaseGetTenantRequest(): GetTenantRequest {
  return { tenantId: "" };
}

export const GetTenantRequest: MessageFns<GetTenantRequest> = {
  encode(message: GetTenantRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tenantId !== "") {
      writer.uint32(10).string(message.tenantId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTenantRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTenantRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tenantId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTenantRequest {
    return { tenantId: isSet(object.tenantId) ? globalThis.String(object.tenantId) : "" };
  },

  toJSON(message: GetTenantRequest): unknown {
    const obj: any = {};
    if (message.tenantId !== "") {
      obj.tenantId = message.tenantId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTenantRequest>, I>>(base?: I): GetTenantRequest {
    return GetTenantRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTenantRequest>, I>>(object: I): GetTenantRequest {
    const message = createBaseGetTenantRequest();
    message.tenantId = object.tenantId ?? "";
    return message;
  },
};

function createBaseDeleteTenantRequest(): DeleteTenantRequest {
  return { tenantId: "" };
}

export const DeleteTenantRequest: MessageFns<DeleteTenantRequest> = {
  encode(message: DeleteTenantRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tenantId !== "") {
      writer.uint32(10).string(message.tenantId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteTenantRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteTenantRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tenantId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteTenantRequest {
    return { tenantId: isSet(object.tenantId) ? globalThis.String(object.tenantId) : "" };
  },

  toJSON(message: DeleteTenantRequest): unknown {
    const obj: any = {};
    if (message.tenantId !== "") {
      obj.tenantId = message.tenantId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteTenantRequest>, I>>(base?: I): DeleteTenantRequest {
    return DeleteTenantRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteTenantRequest>, I>>(object: I): DeleteTenantRequest {
    const message = createBaseDeleteTenantRequest();
    message.tenantId = object.tenantId ?? "";
    return message;
  },
};

function createBaseDeleteTenantsRequest(): DeleteTenantsRequest {
  return { tenantId: [] };
}

export const DeleteTenantsRequest: MessageFns<DeleteTenantsRequest> = {
  encode(message: DeleteTenantsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tenantId) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteTenantsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteTenantsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tenantId.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteTenantsRequest {
    return {
      tenantId: globalThis.Array.isArray(object?.tenantId) ? object.tenantId.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: DeleteTenantsRequest): unknown {
    const obj: any = {};
    if (message.tenantId?.length) {
      obj.tenantId = message.tenantId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteTenantsRequest>, I>>(base?: I): DeleteTenantsRequest {
    return DeleteTenantsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteTenantsRequest>, I>>(object: I): DeleteTenantsRequest {
    const message = createBaseDeleteTenantsRequest();
    message.tenantId = object.tenantId?.map((e) => e) || [];
    return message;
  },
};

function createBaseRefreshAgentSessionRequest(): RefreshAgentSessionRequest {
  return { expiry: "" };
}

export const RefreshAgentSessionRequest: MessageFns<RefreshAgentSessionRequest> = {
  encode(message: RefreshAgentSessionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.expiry !== "") {
      writer.uint32(10).string(message.expiry);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RefreshAgentSessionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRefreshAgentSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.expiry = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RefreshAgentSessionRequest {
    return { expiry: isSet(object.expiry) ? globalThis.String(object.expiry) : "" };
  },

  toJSON(message: RefreshAgentSessionRequest): unknown {
    const obj: any = {};
    if (message.expiry !== "") {
      obj.expiry = message.expiry;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RefreshAgentSessionRequest>, I>>(base?: I): RefreshAgentSessionRequest {
    return RefreshAgentSessionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RefreshAgentSessionRequest>, I>>(object: I): RefreshAgentSessionRequest {
    const message = createBaseRefreshAgentSessionRequest();
    message.expiry = object.expiry ?? "";
    return message;
  },
};

function createBaseStartAgentSessionResponse(): StartAgentSessionResponse {
  return { serialNumber: "", switchId: "", orgId: "", fabricId: "", unclaimed: false, unbound: false, tokens: [] };
}

export const StartAgentSessionResponse: MessageFns<StartAgentSessionResponse> = {
  encode(message: StartAgentSessionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.serialNumber !== "") {
      writer.uint32(10).string(message.serialNumber);
    }
    if (message.switchId !== "") {
      writer.uint32(18).string(message.switchId);
    }
    if (message.orgId !== "") {
      writer.uint32(26).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(42).string(message.fabricId);
    }
    if (message.unclaimed !== false) {
      writer.uint32(56).bool(message.unclaimed);
    }
    if (message.unbound !== false) {
      writer.uint32(64).bool(message.unbound);
    }
    for (const v of message.tokens) {
      Token.encode(v!, writer.uint32(402).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartAgentSessionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartAgentSessionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.switchId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.unclaimed = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.unbound = reader.bool();
          continue;
        }
        case 50: {
          if (tag !== 402) {
            break;
          }

          message.tokens.push(Token.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartAgentSessionResponse {
    return {
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
      switchId: isSet(object.switchId) ? globalThis.String(object.switchId) : "",
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      unclaimed: isSet(object.unclaimed) ? globalThis.Boolean(object.unclaimed) : false,
      unbound: isSet(object.unbound) ? globalThis.Boolean(object.unbound) : false,
      tokens: globalThis.Array.isArray(object?.tokens) ? object.tokens.map((e: any) => Token.fromJSON(e)) : [],
    };
  },

  toJSON(message: StartAgentSessionResponse): unknown {
    const obj: any = {};
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    if (message.switchId !== "") {
      obj.switchId = message.switchId;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.unclaimed !== false) {
      obj.unclaimed = message.unclaimed;
    }
    if (message.unbound !== false) {
      obj.unbound = message.unbound;
    }
    if (message.tokens?.length) {
      obj.tokens = message.tokens.map((e) => Token.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StartAgentSessionResponse>, I>>(base?: I): StartAgentSessionResponse {
    return StartAgentSessionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StartAgentSessionResponse>, I>>(object: I): StartAgentSessionResponse {
    const message = createBaseStartAgentSessionResponse();
    message.serialNumber = object.serialNumber ?? "";
    message.switchId = object.switchId ?? "";
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.unclaimed = object.unclaimed ?? false;
    message.unbound = object.unbound ?? false;
    message.tokens = object.tokens?.map((e) => Token.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetAgentSessionRequest(): GetAgentSessionRequest {
  return {};
}

export const GetAgentSessionRequest: MessageFns<GetAgentSessionRequest> = {
  encode(_: GetAgentSessionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAgentSessionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAgentSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetAgentSessionRequest {
    return {};
  },

  toJSON(_: GetAgentSessionRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAgentSessionRequest>, I>>(base?: I): GetAgentSessionRequest {
    return GetAgentSessionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAgentSessionRequest>, I>>(_: I): GetAgentSessionRequest {
    const message = createBaseGetAgentSessionRequest();
    return message;
  },
};

function createBaseGetAgentSessionResponse(): GetAgentSessionResponse {
  return {
    serialNumber: "",
    switchId: "",
    orgId: "",
    fabricId: "",
    unclaimed: false,
    unbound: false,
    expiry: undefined,
  };
}

export const GetAgentSessionResponse: MessageFns<GetAgentSessionResponse> = {
  encode(message: GetAgentSessionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.serialNumber !== "") {
      writer.uint32(10).string(message.serialNumber);
    }
    if (message.switchId !== "") {
      writer.uint32(18).string(message.switchId);
    }
    if (message.orgId !== "") {
      writer.uint32(26).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(42).string(message.fabricId);
    }
    if (message.unclaimed !== false) {
      writer.uint32(56).bool(message.unclaimed);
    }
    if (message.unbound !== false) {
      writer.uint32(64).bool(message.unbound);
    }
    if (message.expiry !== undefined) {
      Timestamp.encode(toTimestamp(message.expiry), writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAgentSessionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAgentSessionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.switchId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.unclaimed = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.unbound = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.expiry = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAgentSessionResponse {
    return {
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
      switchId: isSet(object.switchId) ? globalThis.String(object.switchId) : "",
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      unclaimed: isSet(object.unclaimed) ? globalThis.Boolean(object.unclaimed) : false,
      unbound: isSet(object.unbound) ? globalThis.Boolean(object.unbound) : false,
      expiry: isSet(object.expiry) ? fromJsonTimestamp(object.expiry) : undefined,
    };
  },

  toJSON(message: GetAgentSessionResponse): unknown {
    const obj: any = {};
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    if (message.switchId !== "") {
      obj.switchId = message.switchId;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.unclaimed !== false) {
      obj.unclaimed = message.unclaimed;
    }
    if (message.unbound !== false) {
      obj.unbound = message.unbound;
    }
    if (message.expiry !== undefined) {
      obj.expiry = message.expiry.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAgentSessionResponse>, I>>(base?: I): GetAgentSessionResponse {
    return GetAgentSessionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAgentSessionResponse>, I>>(object: I): GetAgentSessionResponse {
    const message = createBaseGetAgentSessionResponse();
    message.serialNumber = object.serialNumber ?? "";
    message.switchId = object.switchId ?? "";
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.unclaimed = object.unclaimed ?? false;
    message.unbound = object.unbound ?? false;
    message.expiry = object.expiry ?? undefined;
    return message;
  },
};

function createBaseUpdateUser(): UpdateUser {
  return { role: 0, enabled: false, labels: [], userType: "" };
}

export const UpdateUser: MessageFns<UpdateUser> = {
  encode(message: UpdateUser, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.role !== 0) {
      writer.uint32(8).int32(message.role);
    }
    if (message.enabled !== false) {
      writer.uint32(16).bool(message.enabled);
    }
    for (const v of message.labels) {
      writer.uint32(26).string(v!);
    }
    if (message.userType !== "") {
      writer.uint32(34).string(message.userType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateUser {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateUser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.role = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.userType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateUser {
    return {
      role: isSet(object.role) ? userRoleFromJSON(object.role) : 0,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      userType: isSet(object.userType) ? globalThis.String(object.userType) : "",
    };
  },

  toJSON(message: UpdateUser): unknown {
    const obj: any = {};
    if (message.role !== 0) {
      obj.role = userRoleToJSON(message.role);
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.userType !== "") {
      obj.userType = message.userType;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateUser>, I>>(base?: I): UpdateUser {
    return UpdateUser.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateUser>, I>>(object: I): UpdateUser {
    const message = createBaseUpdateUser();
    message.role = object.role ?? 0;
    message.enabled = object.enabled ?? false;
    message.labels = object.labels?.map((e) => e) || [];
    message.userType = object.userType ?? "";
    return message;
  },
};

function createBaseUpdateUserRequest(): UpdateUserRequest {
  return { userId: "", user: undefined };
}

export const UpdateUserRequest: MessageFns<UpdateUserRequest> = {
  encode(message: UpdateUserRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.user !== undefined) {
      UpdateUser.encode(message.user, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateUserRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateUserRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.user = UpdateUser.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateUserRequest {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      user: isSet(object.user) ? UpdateUser.fromJSON(object.user) : undefined,
    };
  },

  toJSON(message: UpdateUserRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.user !== undefined) {
      obj.user = UpdateUser.toJSON(message.user);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateUserRequest>, I>>(base?: I): UpdateUserRequest {
    return UpdateUserRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateUserRequest>, I>>(object: I): UpdateUserRequest {
    const message = createBaseUpdateUserRequest();
    message.userId = object.userId ?? "";
    message.user = (object.user !== undefined && object.user !== null)
      ? UpdateUser.fromPartial(object.user)
      : undefined;
    return message;
  },
};

function createBaseAddOrgRequest(): AddOrgRequest {
  return { orgName: "", targetGeo: 0 };
}

export const AddOrgRequest: MessageFns<AddOrgRequest> = {
  encode(message: AddOrgRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgName !== "") {
      writer.uint32(10).string(message.orgName);
    }
    if (message.targetGeo !== 0) {
      writer.uint32(16).int32(message.targetGeo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddOrgRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddOrgRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.targetGeo = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddOrgRequest {
    return {
      orgName: isSet(object.orgName) ? globalThis.String(object.orgName) : "",
      targetGeo: isSet(object.targetGeo) ? geoFromJSON(object.targetGeo) : 0,
    };
  },

  toJSON(message: AddOrgRequest): unknown {
    const obj: any = {};
    if (message.orgName !== "") {
      obj.orgName = message.orgName;
    }
    if (message.targetGeo !== 0) {
      obj.targetGeo = geoToJSON(message.targetGeo);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddOrgRequest>, I>>(base?: I): AddOrgRequest {
    return AddOrgRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddOrgRequest>, I>>(object: I): AddOrgRequest {
    const message = createBaseAddOrgRequest();
    message.orgName = object.orgName ?? "";
    message.targetGeo = object.targetGeo ?? 0;
    return message;
  },
};

function createBaseAddOrgResponse(): AddOrgResponse {
  return { orgId: "", user: undefined, cuiTenantId: "" };
}

export const AddOrgResponse: MessageFns<AddOrgResponse> = {
  encode(message: AddOrgResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(18).fork()).join();
    }
    if (message.cuiTenantId !== "") {
      writer.uint32(26).string(message.cuiTenantId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddOrgResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddOrgResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.user = User.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.cuiTenantId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddOrgResponse {
    return {
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
      cuiTenantId: isSet(object.cuiTenantId) ? globalThis.String(object.cuiTenantId) : "",
    };
  },

  toJSON(message: AddOrgResponse): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user);
    }
    if (message.cuiTenantId !== "") {
      obj.cuiTenantId = message.cuiTenantId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddOrgResponse>, I>>(base?: I): AddOrgResponse {
    return AddOrgResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddOrgResponse>, I>>(object: I): AddOrgResponse {
    const message = createBaseAddOrgResponse();
    message.orgId = object.orgId ?? "";
    message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
    message.cuiTenantId = object.cuiTenantId ?? "";
    return message;
  },
};

function createBaseDeleteOrgRequest(): DeleteOrgRequest {
  return {};
}

export const DeleteOrgRequest: MessageFns<DeleteOrgRequest> = {
  encode(_: DeleteOrgRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteOrgRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteOrgRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeleteOrgRequest {
    return {};
  },

  toJSON(_: DeleteOrgRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteOrgRequest>, I>>(base?: I): DeleteOrgRequest {
    return DeleteOrgRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteOrgRequest>, I>>(_: I): DeleteOrgRequest {
    const message = createBaseDeleteOrgRequest();
    return message;
  },
};

function createBaseUpdateSupportAccessRequest(): UpdateSupportAccessRequest {
  return { settings: undefined };
}

export const UpdateSupportAccessRequest: MessageFns<UpdateSupportAccessRequest> = {
  encode(message: UpdateSupportAccessRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.settings !== undefined) {
      SupportSettings.encode(message.settings, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateSupportAccessRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateSupportAccessRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.settings = SupportSettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateSupportAccessRequest {
    return { settings: isSet(object.settings) ? SupportSettings.fromJSON(object.settings) : undefined };
  },

  toJSON(message: UpdateSupportAccessRequest): unknown {
    const obj: any = {};
    if (message.settings !== undefined) {
      obj.settings = SupportSettings.toJSON(message.settings);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateSupportAccessRequest>, I>>(base?: I): UpdateSupportAccessRequest {
    return UpdateSupportAccessRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateSupportAccessRequest>, I>>(object: I): UpdateSupportAccessRequest {
    const message = createBaseUpdateSupportAccessRequest();
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? SupportSettings.fromPartial(object.settings)
      : undefined;
    return message;
  },
};

function createBaseGetSupportAccessRequest(): GetSupportAccessRequest {
  return {};
}

export const GetSupportAccessRequest: MessageFns<GetSupportAccessRequest> = {
  encode(_: GetSupportAccessRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSupportAccessRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSupportAccessRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetSupportAccessRequest {
    return {};
  },

  toJSON(_: GetSupportAccessRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSupportAccessRequest>, I>>(base?: I): GetSupportAccessRequest {
    return GetSupportAccessRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSupportAccessRequest>, I>>(_: I): GetSupportAccessRequest {
    const message = createBaseGetSupportAccessRequest();
    return message;
  },
};

function createBaseSupportAccessResponse(): SupportAccessResponse {
  return { settings: undefined };
}

export const SupportAccessResponse: MessageFns<SupportAccessResponse> = {
  encode(message: SupportAccessResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.settings !== undefined) {
      SupportSettings.encode(message.settings, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SupportAccessResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSupportAccessResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.settings = SupportSettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SupportAccessResponse {
    return { settings: isSet(object.settings) ? SupportSettings.fromJSON(object.settings) : undefined };
  },

  toJSON(message: SupportAccessResponse): unknown {
    const obj: any = {};
    if (message.settings !== undefined) {
      obj.settings = SupportSettings.toJSON(message.settings);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SupportAccessResponse>, I>>(base?: I): SupportAccessResponse {
    return SupportAccessResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SupportAccessResponse>, I>>(object: I): SupportAccessResponse {
    const message = createBaseSupportAccessResponse();
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? SupportSettings.fromPartial(object.settings)
      : undefined;
    return message;
  },
};

function createBaseSignDeviceCertRequest(): SignDeviceCertRequest {
  return { csr: "" };
}

export const SignDeviceCertRequest: MessageFns<SignDeviceCertRequest> = {
  encode(message: SignDeviceCertRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.csr !== "") {
      writer.uint32(10).string(message.csr);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SignDeviceCertRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignDeviceCertRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.csr = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SignDeviceCertRequest {
    return { csr: isSet(object.csr) ? globalThis.String(object.csr) : "" };
  },

  toJSON(message: SignDeviceCertRequest): unknown {
    const obj: any = {};
    if (message.csr !== "") {
      obj.csr = message.csr;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SignDeviceCertRequest>, I>>(base?: I): SignDeviceCertRequest {
    return SignDeviceCertRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SignDeviceCertRequest>, I>>(object: I): SignDeviceCertRequest {
    const message = createBaseSignDeviceCertRequest();
    message.csr = object.csr ?? "";
    return message;
  },
};

function createBaseSignDeviceCertResponse(): SignDeviceCertResponse {
  return { certChain: "" };
}

export const SignDeviceCertResponse: MessageFns<SignDeviceCertResponse> = {
  encode(message: SignDeviceCertResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.certChain !== "") {
      writer.uint32(10).string(message.certChain);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SignDeviceCertResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignDeviceCertResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.certChain = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SignDeviceCertResponse {
    return { certChain: isSet(object.certChain) ? globalThis.String(object.certChain) : "" };
  },

  toJSON(message: SignDeviceCertResponse): unknown {
    const obj: any = {};
    if (message.certChain !== "") {
      obj.certChain = message.certChain;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SignDeviceCertResponse>, I>>(base?: I): SignDeviceCertResponse {
    return SignDeviceCertResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SignDeviceCertResponse>, I>>(object: I): SignDeviceCertResponse {
    const message = createBaseSignDeviceCertResponse();
    message.certChain = object.certChain ?? "";
    return message;
  },
};

function createBaseSignVirtualDeviceCertRequest(): SignVirtualDeviceCertRequest {
  return { csr: "" };
}

export const SignVirtualDeviceCertRequest: MessageFns<SignVirtualDeviceCertRequest> = {
  encode(message: SignVirtualDeviceCertRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.csr !== "") {
      writer.uint32(10).string(message.csr);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SignVirtualDeviceCertRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignVirtualDeviceCertRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.csr = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SignVirtualDeviceCertRequest {
    return { csr: isSet(object.csr) ? globalThis.String(object.csr) : "" };
  },

  toJSON(message: SignVirtualDeviceCertRequest): unknown {
    const obj: any = {};
    if (message.csr !== "") {
      obj.csr = message.csr;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SignVirtualDeviceCertRequest>, I>>(base?: I): SignVirtualDeviceCertRequest {
    return SignVirtualDeviceCertRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SignVirtualDeviceCertRequest>, I>>(object: I): SignVirtualDeviceCertRequest {
    const message = createBaseSignVirtualDeviceCertRequest();
    message.csr = object.csr ?? "";
    return message;
  },
};

function createBaseSignVirtualDeviceCertResponse(): SignVirtualDeviceCertResponse {
  return { certChain: "" };
}

export const SignVirtualDeviceCertResponse: MessageFns<SignVirtualDeviceCertResponse> = {
  encode(message: SignVirtualDeviceCertResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.certChain !== "") {
      writer.uint32(10).string(message.certChain);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SignVirtualDeviceCertResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignVirtualDeviceCertResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.certChain = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SignVirtualDeviceCertResponse {
    return { certChain: isSet(object.certChain) ? globalThis.String(object.certChain) : "" };
  },

  toJSON(message: SignVirtualDeviceCertResponse): unknown {
    const obj: any = {};
    if (message.certChain !== "") {
      obj.certChain = message.certChain;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SignVirtualDeviceCertResponse>, I>>(base?: I): SignVirtualDeviceCertResponse {
    return SignVirtualDeviceCertResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SignVirtualDeviceCertResponse>, I>>(
    object: I,
  ): SignVirtualDeviceCertResponse {
    const message = createBaseSignVirtualDeviceCertResponse();
    message.certChain = object.certChain ?? "";
    return message;
  },
};

function createBaseInternalSubscriptionRequest(): InternalSubscriptionRequest {
  return { creator: "", refId: "", pid: "", quantity: 0, startDate: "", term: 0 };
}

export const InternalSubscriptionRequest: MessageFns<InternalSubscriptionRequest> = {
  encode(message: InternalSubscriptionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.creator !== "") {
      writer.uint32(10).string(message.creator);
    }
    if (message.refId !== "") {
      writer.uint32(18).string(message.refId);
    }
    if (message.pid !== "") {
      writer.uint32(26).string(message.pid);
    }
    if (message.quantity !== 0) {
      writer.uint32(32).uint32(message.quantity);
    }
    if (message.startDate !== "") {
      writer.uint32(42).string(message.startDate);
    }
    if (message.term !== 0) {
      writer.uint32(48).uint32(message.term);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InternalSubscriptionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInternalSubscriptionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.creator = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.refId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.pid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.quantity = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.startDate = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.term = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InternalSubscriptionRequest {
    return {
      creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
      refId: isSet(object.refId) ? globalThis.String(object.refId) : "",
      pid: isSet(object.pid) ? globalThis.String(object.pid) : "",
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      startDate: isSet(object.startDate) ? globalThis.String(object.startDate) : "",
      term: isSet(object.term) ? globalThis.Number(object.term) : 0,
    };
  },

  toJSON(message: InternalSubscriptionRequest): unknown {
    const obj: any = {};
    if (message.creator !== "") {
      obj.creator = message.creator;
    }
    if (message.refId !== "") {
      obj.refId = message.refId;
    }
    if (message.pid !== "") {
      obj.pid = message.pid;
    }
    if (message.quantity !== 0) {
      obj.quantity = Math.round(message.quantity);
    }
    if (message.startDate !== "") {
      obj.startDate = message.startDate;
    }
    if (message.term !== 0) {
      obj.term = Math.round(message.term);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InternalSubscriptionRequest>, I>>(base?: I): InternalSubscriptionRequest {
    return InternalSubscriptionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InternalSubscriptionRequest>, I>>(object: I): InternalSubscriptionRequest {
    const message = createBaseInternalSubscriptionRequest();
    message.creator = object.creator ?? "";
    message.refId = object.refId ?? "";
    message.pid = object.pid ?? "";
    message.quantity = object.quantity ?? 0;
    message.startDate = object.startDate ?? "";
    message.term = object.term ?? 0;
    return message;
  },
};

function createBaseUpdateOrgRequest(): UpdateOrgRequest {
  return { organization: undefined };
}

export const UpdateOrgRequest: MessageFns<UpdateOrgRequest> = {
  encode(message: UpdateOrgRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.organization !== undefined) {
      Organization.encode(message.organization, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateOrgRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateOrgRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.organization = Organization.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateOrgRequest {
    return { organization: isSet(object.organization) ? Organization.fromJSON(object.organization) : undefined };
  },

  toJSON(message: UpdateOrgRequest): unknown {
    const obj: any = {};
    if (message.organization !== undefined) {
      obj.organization = Organization.toJSON(message.organization);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateOrgRequest>, I>>(base?: I): UpdateOrgRequest {
    return UpdateOrgRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateOrgRequest>, I>>(object: I): UpdateOrgRequest {
    const message = createBaseUpdateOrgRequest();
    message.organization = (object.organization !== undefined && object.organization !== null)
      ? Organization.fromPartial(object.organization)
      : undefined;
    return message;
  },
};

function createBaseSignEulaRequest(): SignEulaRequest {
  return { eula: undefined };
}

export const SignEulaRequest: MessageFns<SignEulaRequest> = {
  encode(message: SignEulaRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.eula !== undefined) {
      Eula.encode(message.eula, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SignEulaRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignEulaRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.eula = Eula.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SignEulaRequest {
    return { eula: isSet(object.eula) ? Eula.fromJSON(object.eula) : undefined };
  },

  toJSON(message: SignEulaRequest): unknown {
    const obj: any = {};
    if (message.eula !== undefined) {
      obj.eula = Eula.toJSON(message.eula);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SignEulaRequest>, I>>(base?: I): SignEulaRequest {
    return SignEulaRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SignEulaRequest>, I>>(object: I): SignEulaRequest {
    const message = createBaseSignEulaRequest();
    message.eula = (object.eula !== undefined && object.eula !== null) ? Eula.fromPartial(object.eula) : undefined;
    return message;
  },
};

function createBaseSignEulaResponse(): SignEulaResponse {
  return { tenantId: "" };
}

export const SignEulaResponse: MessageFns<SignEulaResponse> = {
  encode(message: SignEulaResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tenantId !== "") {
      writer.uint32(10).string(message.tenantId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SignEulaResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSignEulaResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tenantId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SignEulaResponse {
    return { tenantId: isSet(object.tenantId) ? globalThis.String(object.tenantId) : "" };
  },

  toJSON(message: SignEulaResponse): unknown {
    const obj: any = {};
    if (message.tenantId !== "") {
      obj.tenantId = message.tenantId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SignEulaResponse>, I>>(base?: I): SignEulaResponse {
    return SignEulaResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SignEulaResponse>, I>>(object: I): SignEulaResponse {
    const message = createBaseSignEulaResponse();
    message.tenantId = object.tenantId ?? "";
    return message;
  },
};

function createBaseIntrospectCUITokenRequest(): IntrospectCUITokenRequest {
  return { token: "" };
}

export const IntrospectCUITokenRequest: MessageFns<IntrospectCUITokenRequest> = {
  encode(message: IntrospectCUITokenRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntrospectCUITokenRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntrospectCUITokenRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.token = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IntrospectCUITokenRequest {
    return { token: isSet(object.token) ? globalThis.String(object.token) : "" };
  },

  toJSON(message: IntrospectCUITokenRequest): unknown {
    const obj: any = {};
    if (message.token !== "") {
      obj.token = message.token;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IntrospectCUITokenRequest>, I>>(base?: I): IntrospectCUITokenRequest {
    return IntrospectCUITokenRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IntrospectCUITokenRequest>, I>>(object: I): IntrospectCUITokenRequest {
    const message = createBaseIntrospectCUITokenRequest();
    message.token = object.token ?? "";
    return message;
  },
};

function createBaseIntrospectCUITokenResponse(): IntrospectCUITokenResponse {
  return { cuiOrgId: "", cuiTenantId: "", cuiUserId: "" };
}

export const IntrospectCUITokenResponse: MessageFns<IntrospectCUITokenResponse> = {
  encode(message: IntrospectCUITokenResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cuiOrgId !== "") {
      writer.uint32(10).string(message.cuiOrgId);
    }
    if (message.cuiTenantId !== "") {
      writer.uint32(18).string(message.cuiTenantId);
    }
    if (message.cuiUserId !== "") {
      writer.uint32(26).string(message.cuiUserId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntrospectCUITokenResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntrospectCUITokenResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.cuiOrgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cuiTenantId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.cuiUserId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IntrospectCUITokenResponse {
    return {
      cuiOrgId: isSet(object.cuiOrgId) ? globalThis.String(object.cuiOrgId) : "",
      cuiTenantId: isSet(object.cuiTenantId) ? globalThis.String(object.cuiTenantId) : "",
      cuiUserId: isSet(object.cuiUserId) ? globalThis.String(object.cuiUserId) : "",
    };
  },

  toJSON(message: IntrospectCUITokenResponse): unknown {
    const obj: any = {};
    if (message.cuiOrgId !== "") {
      obj.cuiOrgId = message.cuiOrgId;
    }
    if (message.cuiTenantId !== "") {
      obj.cuiTenantId = message.cuiTenantId;
    }
    if (message.cuiUserId !== "") {
      obj.cuiUserId = message.cuiUserId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IntrospectCUITokenResponse>, I>>(base?: I): IntrospectCUITokenResponse {
    return IntrospectCUITokenResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IntrospectCUITokenResponse>, I>>(object: I): IntrospectCUITokenResponse {
    const message = createBaseIntrospectCUITokenResponse();
    message.cuiOrgId = object.cuiOrgId ?? "";
    message.cuiTenantId = object.cuiTenantId ?? "";
    message.cuiUserId = object.cuiUserId ?? "";
    return message;
  },
};

function createBaseSendOrgInviteEmailRequest(): SendOrgInviteEmailRequest {
  return { email: "", dryRun: false };
}

export const SendOrgInviteEmailRequest: MessageFns<SendOrgInviteEmailRequest> = {
  encode(message: SendOrgInviteEmailRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    if (message.dryRun !== false) {
      writer.uint32(16).bool(message.dryRun);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendOrgInviteEmailRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendOrgInviteEmailRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.dryRun = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendOrgInviteEmailRequest {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      dryRun: isSet(object.dryRun) ? globalThis.Boolean(object.dryRun) : false,
    };
  },

  toJSON(message: SendOrgInviteEmailRequest): unknown {
    const obj: any = {};
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.dryRun !== false) {
      obj.dryRun = message.dryRun;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendOrgInviteEmailRequest>, I>>(base?: I): SendOrgInviteEmailRequest {
    return SendOrgInviteEmailRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendOrgInviteEmailRequest>, I>>(object: I): SendOrgInviteEmailRequest {
    const message = createBaseSendOrgInviteEmailRequest();
    message.email = object.email ?? "";
    message.dryRun = object.dryRun ?? false;
    return message;
  },
};

function createBaseSendOrgInviteEmailResponse(): SendOrgInviteEmailResponse {
  return {
    orgName: "",
    orgId: "",
    inviteUrl: "",
    requesterEmail: "",
    inviteeEmail: "",
    expiresAt: undefined,
    sentAt: undefined,
  };
}

export const SendOrgInviteEmailResponse: MessageFns<SendOrgInviteEmailResponse> = {
  encode(message: SendOrgInviteEmailResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgName !== "") {
      writer.uint32(10).string(message.orgName);
    }
    if (message.orgId !== "") {
      writer.uint32(18).string(message.orgId);
    }
    if (message.inviteUrl !== "") {
      writer.uint32(26).string(message.inviteUrl);
    }
    if (message.requesterEmail !== "") {
      writer.uint32(34).string(message.requesterEmail);
    }
    if (message.inviteeEmail !== "") {
      writer.uint32(42).string(message.inviteeEmail);
    }
    if (message.expiresAt !== undefined) {
      Timestamp.encode(toTimestamp(message.expiresAt), writer.uint32(50).fork()).join();
    }
    if (message.sentAt !== undefined) {
      Timestamp.encode(toTimestamp(message.sentAt), writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendOrgInviteEmailResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendOrgInviteEmailResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.inviteUrl = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.requesterEmail = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.inviteeEmail = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.expiresAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.sentAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendOrgInviteEmailResponse {
    return {
      orgName: isSet(object.orgName) ? globalThis.String(object.orgName) : "",
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      inviteUrl: isSet(object.inviteUrl) ? globalThis.String(object.inviteUrl) : "",
      requesterEmail: isSet(object.requesterEmail) ? globalThis.String(object.requesterEmail) : "",
      inviteeEmail: isSet(object.inviteeEmail) ? globalThis.String(object.inviteeEmail) : "",
      expiresAt: isSet(object.expiresAt) ? fromJsonTimestamp(object.expiresAt) : undefined,
      sentAt: isSet(object.sentAt) ? fromJsonTimestamp(object.sentAt) : undefined,
    };
  },

  toJSON(message: SendOrgInviteEmailResponse): unknown {
    const obj: any = {};
    if (message.orgName !== "") {
      obj.orgName = message.orgName;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.inviteUrl !== "") {
      obj.inviteUrl = message.inviteUrl;
    }
    if (message.requesterEmail !== "") {
      obj.requesterEmail = message.requesterEmail;
    }
    if (message.inviteeEmail !== "") {
      obj.inviteeEmail = message.inviteeEmail;
    }
    if (message.expiresAt !== undefined) {
      obj.expiresAt = message.expiresAt.toISOString();
    }
    if (message.sentAt !== undefined) {
      obj.sentAt = message.sentAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendOrgInviteEmailResponse>, I>>(base?: I): SendOrgInviteEmailResponse {
    return SendOrgInviteEmailResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendOrgInviteEmailResponse>, I>>(object: I): SendOrgInviteEmailResponse {
    const message = createBaseSendOrgInviteEmailResponse();
    message.orgName = object.orgName ?? "";
    message.orgId = object.orgId ?? "";
    message.inviteUrl = object.inviteUrl ?? "";
    message.requesterEmail = object.requesterEmail ?? "";
    message.inviteeEmail = object.inviteeEmail ?? "";
    message.expiresAt = object.expiresAt ?? undefined;
    message.sentAt = object.sentAt ?? undefined;
    return message;
  },
};

function createBaseC3UserSessionStartRequest(): C3UserSessionStartRequest {
  return { accessToken: "", issuer: "", isCrosslaunch: false, c3BaseUrl: "" };
}

export const C3UserSessionStartRequest: MessageFns<C3UserSessionStartRequest> = {
  encode(message: C3UserSessionStartRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.accessToken !== "") {
      writer.uint32(10).string(message.accessToken);
    }
    if (message.issuer !== "") {
      writer.uint32(18).string(message.issuer);
    }
    if (message.isCrosslaunch !== false) {
      writer.uint32(24).bool(message.isCrosslaunch);
    }
    if (message.c3BaseUrl !== "") {
      writer.uint32(34).string(message.c3BaseUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): C3UserSessionStartRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseC3UserSessionStartRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.accessToken = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.issuer = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isCrosslaunch = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.c3BaseUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): C3UserSessionStartRequest {
    return {
      accessToken: isSet(object.accessToken) ? globalThis.String(object.accessToken) : "",
      issuer: isSet(object.issuer) ? globalThis.String(object.issuer) : "",
      isCrosslaunch: isSet(object.isCrosslaunch) ? globalThis.Boolean(object.isCrosslaunch) : false,
      c3BaseUrl: isSet(object.c3BaseUrl) ? globalThis.String(object.c3BaseUrl) : "",
    };
  },

  toJSON(message: C3UserSessionStartRequest): unknown {
    const obj: any = {};
    if (message.accessToken !== "") {
      obj.accessToken = message.accessToken;
    }
    if (message.issuer !== "") {
      obj.issuer = message.issuer;
    }
    if (message.isCrosslaunch !== false) {
      obj.isCrosslaunch = message.isCrosslaunch;
    }
    if (message.c3BaseUrl !== "") {
      obj.c3BaseUrl = message.c3BaseUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<C3UserSessionStartRequest>, I>>(base?: I): C3UserSessionStartRequest {
    return C3UserSessionStartRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<C3UserSessionStartRequest>, I>>(object: I): C3UserSessionStartRequest {
    const message = createBaseC3UserSessionStartRequest();
    message.accessToken = object.accessToken ?? "";
    message.issuer = object.issuer ?? "";
    message.isCrosslaunch = object.isCrosslaunch ?? false;
    message.c3BaseUrl = object.c3BaseUrl ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000).toString();
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
